// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconWallet } from '@tabler/icons-react';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';

const icons = {
  IconWallet,
  AssessmentOutlinedIcon,
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const wallet = {
  id: 'wallet',
  type: 'group',
  children: [
    {
      id: 'wallet',
      title: <FormattedMessage id="wallet" />,
      type: 'item',
      url: '/wallet',
      icon: icons.IconWallet,
      breadcrumbs: false,
    },
    {
      id: 'Dashboard',
      title: <FormattedMessage id="Dashboard" />,
      type: 'item',
      url: '/boi',
      icon: icons.AssessmentOutlinedIcon,
      breadcrumbs: false,
    },
  ],
};

export default wallet;
